export default "/assets/images/performance-filter-img-01.png?88f3e177692d16b32a471def8cafcc22";